import { useSearchParams } from 'react-router';
import { ArticleListProps } from './contracts';
import ArticleListUI from './ArticleListUI';
import { useArticlesQuery } from '@data/articles/useArticlesQuery';
import { SkeletonLoader } from '@ui/common/components/SkeletonLoader/SkeletonLoader';
export function ArticleList({
  teamFromSlug,
  startDate,
  endDate,
  tags: extraTags,
  tagsMatchMode,
  excludeTags,
  excludeIds,
  filterByTags,
  extraData,
  sort,
  order,
  limit = 1,
  ...props
}: ArticleListProps) {
  const [searchParams] = useSearchParams();
  const offset =
    searchParams.get('offset') && typeof parseInt(searchParams.get('offset') as string) === 'number'
      ? parseInt(searchParams.get('offset') as string)
      : 1;

  let tags = '';

  if (extraTags) {
    tags = extraTags;
  } else if (filterByTags && searchParams.get('tags')) {
    tags = searchParams.get('tags') as string;
  } else if (teamFromSlug && extraData?.team?.slug) {
    tags = extraData?.team?.slug;
  }

  const { data, isLoading, error } = useArticlesQuery({
    startDate: startDate ?? undefined,
    endDate: endDate ?? undefined,
    tags,
    tagsMatchMode: tagsMatchMode ?? undefined,
    page: offset,
    limit: limit ?? undefined,
    sort: sort ?? undefined,
    order: order ?? undefined,
    excludeIds: excludeIds ?? undefined,
    excludeTags: excludeTags ?? undefined,
  });

  if (isLoading) {
    return (
      <div style={{ display: 'block', width: '100%', height: '100%' }}>
        <SkeletonLoader count={limit * 5 - 1} />
      </div>
    );
  }

  if (!data || error) {
    return null;
  }

  return <ArticleListUI paginatedArticles={data} {...props} />;
}
